// Service
import AuthOrganizationService from "services/Auth.Organization.service";

// Model
import SyslogServerModel from "./models/SyslogServer";

const getSyslogServer = async (orgId) => {
  const response = await AuthOrganizationService.getSyslog(orgId);
  return response;
}

const parseRawData = (rawDataList, selectedOrg) => {
  const list = [];

  for (const rawData of rawDataList) {
    list.push(new SyslogServerModel(rawData, selectedOrg));
  }

  return list;
}

const getRemainingSiteList = (managedSiteList, syslogServerList) => {
  const occupiedSite = {};
  const remainingSiteLIst = [];

  for (const syslogServer of syslogServerList) {
    for (const site of syslogServer.siteList) {
      occupiedSite[site.id] = site;
    }
  }

  for (const site of managedSiteList) {
    !occupiedSite[site.id] && remainingSiteLIst.push(site);
  }

  return remainingSiteLIst;
}

const addOrSaveSyslogServer = async (orgId, selectedSyslogServerId, syslogServerState) => {
  const payload = {
    name: syslogServerState.name.value,
    host: syslogServerState.server.value,
    port: syslogServerState.port.value,
    protocol: syslogServerState.protocol.selected.value,
    storeIds: []
  };

  syslogServerState.site.list.forEach(site => {
    if (site.id !== 0 && site.checked) {
      payload.storeIds.push(site.id);
    }
  });

  const response = await AuthOrganizationService.addOrUpdateSyslog(orgId, selectedSyslogServerId, payload);

  return response;
}

const getCheckAllState = (syslogServerList) => {
  let checkedAll = true;
  let noOccupiedNumber = 0;
  let occupiedNumber = 0;

  for (const syslogServer of syslogServerList) {
    syslogServer.siteList.length === 0 && noOccupiedNumber++;
    syslogServer.siteList.length > 0 && occupiedNumber++;

    if (syslogServer.siteList.length === 0 && !syslogServer.checked) {
      checkedAll = false;
    }
  }

  (noOccupiedNumber === 0 && occupiedNumber > 0) && (checkedAll = false);
  return checkedAll;
}

const toggleCheckedAll = (syslogServerList) => {
  let nowState = getCheckAllState(syslogServerList);

  const updatedSyslogServerList = [...syslogServerList];
  for (const syslogServer of updatedSyslogServerList) {
    syslogServer.siteList.length === 0 && (syslogServer.checked = !nowState);
  }

  return updatedSyslogServerList;
}

const getDeleteButtonState = (syslogServerList) => {
  let canDelete = false;
  for (const syslogServer of syslogServerList) {
    if (syslogServer.checked) {
      canDelete = true;
    }
  }

  return canDelete;
}

const toggleChecked = (syslogServerList, index) => {
  const updatedSyslogServerList = [...syslogServerList];
  updatedSyslogServerList[index].checked = !updatedSyslogServerList[index].checked;
  return updatedSyslogServerList;
}

const deleteSyslogServer = async (orgId, idList) => {
  const payload = { ids: idList };
  const response = await AuthOrganizationService.deleteSyslog(orgId, payload);

  return response;
}

export default {
  getSyslogServer,
  parseRawData,
  getRemainingSiteList,
  addOrSaveSyslogServer,
  getCheckAllState,
  toggleCheckedAll,
  toggleChecked,
  getDeleteButtonState,
  deleteSyslogServer
};